import { Link } from "react-router-dom";
import { LOGO, BRAND, COMMUNITIES } from "@/lib/config";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => (
  <footer className="bg-boco-navydark text-slate-300">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-4">
      <div className="md:col-span-1">
        <div className="flex items-center gap-3">
          <img src={LOGO} alt="BOCO BINS LLC" className="h-14 w-14 rounded-full object-cover" />
          <div className="font-display font-extrabold text-white text-lg">
            BOCO BINS <span className="text-boco-green">LLC</span>
          </div>
        </div>
        <p className="mt-4 text-sm text-slate-400 leading-relaxed">
          Local. Professional. Clean. Serving Buchanan, Botetourt County and surrounding communities.
        </p>
      </div>

      <div>
        <h4 className="text-white font-display font-bold mb-4 text-sm tracking-wide">CONTACT</h4>
        <ul className="space-y-3 text-sm">
          <li><a href={BRAND.phoneHref} className="flex items-center gap-2 hover:text-boco-green transition-colors" data-testid="footer-phone"><Phone className="h-4 w-4" /> {BRAND.phone}</a></li>
          <li><a href={`mailto:${BRAND.email}`} className="flex items-center gap-2 hover:text-boco-green transition-colors" data-testid="footer-email"><Mail className="h-4 w-4" /> {BRAND.email}</a></li>
          <li className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {BRAND.location}</li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-display font-bold mb-4 text-sm tracking-wide">SERVICE AREA</h4>
        <ul className="space-y-2 text-sm text-slate-400">
          {COMMUNITIES.map((c) => (<li key={c}>{c}, VA</li>))}
        </ul>
        <Link to="/pressure-washing" className="mt-4 inline-block text-sm font-semibold text-boco-green hover:text-white transition-colors" data-testid="footer-pressure-washing">Pressure Washing →</Link>
      </div>

      <div>
        <h4 className="text-white font-display font-bold mb-4 text-sm tracking-wide">GET STARTED</h4>
        <Link to="/book" className="inline-flex rounded-full bg-boco-green px-5 py-2.5 text-sm font-bold text-boco-navy hover:bg-white transition-colors" data-testid="footer-book-btn">
          Book Your Cleaning
        </Link>
        <div className="mt-6">
          <Link to="/terms" className="text-xs text-slate-400 hover:text-boco-green transition-colors mr-4" data-testid="footer-terms-link">Terms of Service</Link>
          <Link to="/admin/login" className="text-xs text-slate-500 hover:text-slate-300 transition-colors" data-testid="footer-admin-link">Owner Login</Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} BOCO BINS LLC · Based in Buchanan, VA · Serving surrounding communities
    </div>
  </footer>
);
